export default "__VITE_ASSET__BsgyeRqv__"